var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoDocumentsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.29 24.35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "co-documents_inline_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "co-documents_inline_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "co-documents_inline_svg__Layer_1",
    "data-name": "Layer 1",
    fill: "#fdc800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3v21.35h17.25V21.3h3V0H3v3zm16.23 20.33H1V4.06h11.68v3.55h3.55v15.72zM13.7 4.78l1.81 1.81H13.7zM4.06 1h15.22v19.29h-2V6.89L13.4 3H4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04 9.64H14.2v1.01H3.04zm0 3.04H14.2v1.01H3.04zm0 3.04H14.2v1.01H3.04zm0 4.06h4.57v1.01H3.04zm6.6 0h4.57v1.01H9.64zM6.59 6.59h4.06V7.6H6.59z"
  }))))));
}

export default SvgCoDocumentsinline;